import { Badge } from '@ovComponents/2-component/badge/badge';
import { Box, LinearProgress, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { BORDERED_BOX_SX, SECONDARY_TEXT_SX } from '../styles';
import { formatElapsedMinutes } from '../utils/relativeTimeI18n';
export type OperationRowProps = {
  badgeLabel: string;
  badgeColor: 'warning' | 'neutral';
  title: string;
  progress: number;
  stateLabel: string;
  elapsed: number;
  accentColor?: string;
};

const OperationRow = ({
  badgeLabel,
  badgeColor,
  title,
  progress,
  stateLabel,
  elapsed,
  accentColor,
}: OperationRowProps) => {
  const { t } = useTranslation('portfolioTradingHub');

  return (
    <Box
      sx={{
        mb: 1,
        p: 1,
        ...BORDERED_BOX_SX,
        borderLeft: '3px solid',
        borderLeftColor: accentColor,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 0.25,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.75,
          }}
        >
          <Badge label={badgeLabel} color={badgeColor} />
          <Typography variant='labelSmall' sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <Typography variant='labelSmall' sx={SECONDARY_TEXT_SX}>
          {formatElapsedMinutes(elapsed, t)}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Box
          sx={{
            flex: 1,
          }}
        >
          <LinearProgress variant='determinate' value={progress} size='small' />
        </Box>
        <Typography
          variant='labelSmall'
          sx={{ fontWeight: 600, minWidth: 80, textAlign: 'right' }}
        >
          {stateLabel}
        </Typography>
      </Box>
    </Box>
  );
};

export default OperationRow;
